module.exports = __webpack_public_path__ + "img/HR.f4e06f4d.svg";